<template>
  <div>
    <div id="data-endorsement-list-view" class="data-list-container">
      <vs-table
        noDataText="Nenhuma operação encontrada"
        class="tablePrincipal"
        ref="table"
        pagination
        :max-items="itemsPerPage"
        :data="endorsementData"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <div>
            <vs-button
              v-if="$can($actionsDefault.Escrita, subjectPermission)"
              @click="openModal"
              color="primary"
              icon="add_circle_outline"
              class="h-12 mr-4 flex items-center justify-center px-4 font-bold"
            >
              Cadastrar
            </vs-button>
          </div>
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2">{{ paginationText }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage = 5">
                <span>5</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 25">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 50">
                <span>50</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <template slot="thead">
          <vs-th style="width: 20%">Tipo de Operação</vs-th>
          <vs-th style="width: 10%">Recalcula?</vs-th>
          <vs-th style="width: 15%">Tipo de Recálculo</vs-th>
          <vs-th style="width: 20%">Método de Cálculo</vs-th>
          <vs-th style="width: 10%">Status</vs-th>
          <vs-th style="width: 10%">Ações</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr v-for="(row, index) in data" :key="index">
              <vs-td>{{ row.operationType }}</vs-td>
              <vs-td>
                <vs-chip
                  :color="row.recalculate ? 'success' : 'danger'"
                  class="font-bold"
                >
                  {{ row.recalculate ? 'Sim' : 'Não' }}
                </vs-chip>
              </vs-td>
              <vs-td>{{ row.recalculationType || '-' }}</vs-td>
              <vs-td>{{ row.timeCalculationMethod || '-' }}</vs-td>
              <vs-td>
                <vs-chip
                  :color="row.isActive ? 'success' : 'danger'"
                  class="font-bold"
                >
                  {{ row.isActive ? 'Ativo' : 'Inativo' }}
                </vs-chip>
              </vs-td>
              <vs-td class="vx-row">
                <div
                  class="flex items-center gap-2"
                  v-if="$can($actionsDefault.Escrita, subjectPermission)"
                >
                  <vs-button
                    v-tooltip="'Historico de Alterações'"
                    radius
                    color="#88abc2"
                    icon-pack="feather"
                    icon="icon-archive"
                    class="d-inline ml-2"
                    @click="openHistoryModal(row.id)"
                  />
                  <vs-button
                    v-tooltip="'Editar'"
                    radius
                    color="success"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-edit"
                    class="d-inline ml-2"
                    @click="editOperation(row)"
                  />
                  <vs-button
                    v-tooltip="'Excluir'"
                    radius
                    color="danger"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-trash"
                    class="d-inline ml-2"
                    @click="confirmDelete(row)"
                  />
                </div>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
    <EndorsementModal
      :isOpen="isModalOpen"
      classContent="endorsement-modal"
      :endorsement="selectedEndorsement"
      :profiles="profiles"
      @close="isModalOpen = false"
      @save="handleSave"
    />
    <EndorsementHistoryModal
      :isOpen="isHistoryModalOpen"
      :operationTypeId="selectedEndorsementId"
      @close="isHistoryModalOpen = false"
    />
    <Modal
      :active="isDeleteModalOpen"
      title="Confirmação de Exclusão"
      class="operation-type-modal"
      @update:active="isDeleteModalOpen = $event"
      @close="isDeleteModalOpen = false"
    >
      <div>
        <p>
          Tem certeza que deseja excluir o Tipo de Operação
          <strong>
            {{ endorsementToDelete && endorsementToDelete.operationType }}
          </strong>
          ?
        </p>
      </div>
      <div class="form-actions">
        <vs-button @click="deleteOperationType" color="danger" block>
          Excluir
        </vs-button>
        <vs-button
          @click="isDeleteModalOpen = false"
          color="dark"
          outline
          block
        >
          Cancelar
        </vs-button>
      </div>
    </Modal>
  </div>
</template>

<script>
import EndorsementModal from './EndorsementModal.vue';
import EndorsementHistoryModal from './EndorsementHistoryModal.vue';
import Modal from '../../../../../components/Modal.vue';
import endorsement from '../../../../../services/endorsement';
import notify from '../../../../../utils/notify';
import profileApi from "../../../../../services/profile.api";

export default {
  name: 'EndorsementList',
  props: ['subjectPermission'],
  components: { EndorsementModal, EndorsementHistoryModal, Modal },
  data() {
    return {
      itemsPerPage: 50,
      currentPage: 1,
      selectedEndorsement: null,
      isModalOpen: false,
      isDeleteModalOpen: false,
      endorsementToDelete: null,
      endorsementData: [],
      isHistoryModalOpen: false,
      selectedEndorsementId: null,
      profiles: [],
    };
  },
  computed: {
    paginationText() {
      const start =
        this.currentPage * this.itemsPerPage - (this.itemsPerPage - 1);

      const end =
        this.endorsementData.length - this.currentPage * this.itemsPerPage > 0
          ? this.currentPage * this.itemsPerPage
          : this.endorsementData.length;

      return `${start} - ${end} de ${this.endorsementData.length}`;
    },
  },
  mounted() {
    this.getOperationType();
    this.getProfiles();
  },
  methods: {
    async getProfiles() {
      const profilesFromDatabase = await profileApi.getProfiles();
      this.profiles = profilesFromDatabase.map(profile => ({
        id: profile.id,
        label: profile.name,
      }));
    },
    getProfileLabelById(id) {
      const profile = this.profiles.find(p => p.id === id);
      return profile ? profile.label : `ID ${id}`;
    },
    async getOperationType() {
      this.endorsementData = await endorsement.getOperationType();
    },
    openHistoryModal(operationTypeId) {
      this.selectedEndorsementId = operationTypeId;
      this.isHistoryModalOpen = true;
    },
    editOperation(data) {
      this.selectedEndorsement = { ...data };
      this.isModalOpen = true;
    },
    openModal(data = null) {
      this.selectedEndorsement = data ? { ...data } : null;
      this.isModalOpen = true;
    },
    async handleSave() {
      this.getOperationType();
      this.isModalOpen = false;
    },
    confirmDelete(operationType) {
      this.endorsementToDelete = operationType;
      this.isDeleteModalOpen = true;
    },
    async deleteOperationType() {
      try {
        await endorsement.deleteOperationType(this.endorsementToDelete.id);
        notify.notifySuccess(
          this.$vs,
          `Tipo de Operação ${this.endorsementToDelete.operationType} foi excluído com sucesso.`,
          'Sucesso',
        );

        await this.getOperationType();
      } catch (error) {
        notify.notifyFail(
          this.$vs,
          'Erro ao excluir o Tipo de Operação. Tente novamente.',
        );
      } finally {
        this.isDeleteModalOpen = false;
        this.endorsementToDelete = null;
      }
    },
  },
};
</script>

<style>
#data-endorsement-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px 8px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }

      .error-border {
        border: 2px solid orange;
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

.endorsement-modal {
  overflow: visible !important;
}

[classContent='endorsement-modal'] .vs-popup {
  width: 1400px !important;
  max-width: 90vw;
  max-height: 90vh;
  overflow: hidden;
}

[classContent='endorsement-modal'] .vs-popup--content {
  overflow: hidden;
}
</style>
